/*
================================================================ 
     Copyright (c) 2018-2019 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { Suspense, useEffect, useState, useRef } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Callback from "./auth/callback";
import SilentCallback from "./auth/silentcallback";
import Login from "./auth/login";
import Loader from "./component/loader";
import { connect } from "react-redux";
import actionTypes from "./store/actions";
import ConfirmOrder from "./pages/sales/confirmOrder/confirmOrder";
import ApiPortal from "./pages/api/apiPortal/apiPortal";
import Registration from "./pages/api/registration/registration";
import ApiReadOnly from "./pages/api/apiReadOnly/apiReadOnly";
import InternalAPI from "./pages/api/internalAPI/internalApi";
import SDK from "./pages/api/sdk/sdk";
import ApiRef from "./pages/api/apiRef/apiRef";

import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import InfoIcon from "./asset/images/info.svg";
import { Tooltip, Drawer } from "@mui/material";
import helpScreensList from "./helper/helpScreensList";
// import MUIRichTextEditor from "mui-rte";
// import { createTheme, MuiThemeProvider } from '@mui/material/styles';
import Button from "./component/button";
import BusApiCall from "./helper/axios";
import constants from "./helper/constants";
import SignUp from "./auth/signUp";

import productsPdf from "./files/Product_Management_User_Guide.pdf";
import createPackagePdf from "./files/Create_Product_Offerings_User_Guide.pdf";
import generalPdf from "./files/general.pdf";

import OfferingGuidePdf from "./files/Offerings_Main_Page_And_Rules_User_Guide.pdf";
import OrderUserGuidePdf from "./files/Orders_User_Guide.pdf";
import CustomerUserGuidePdf from "./files/Customer_user_guide.pdf";
import AddonUserGuidePdf from "./files/Addon_Management_Guide.pdf";
import BillingUserGuidePdf from "./files/Billing_Management_Guide.pdf";
import QuoteUserGuidePdf from "./files/Quotes_Management_Guide.pdf";
import SubscriptionUserGuidePdf from "./files/Subscription_Management_Guide.pdf";
import ServiceUserGuidePdf from "./files/Services_Management_Guide.pdf";
import SettlementGuidePdf from "./files/Settlement_Management_User_Guide.pdf";
import ReportsGuidePdf from "./files/Reports_Management_User_Guide.pdf";
import DashboardPdf from "./files/dashboard_Guide.pdf";
import LeadsManagementGuidePdf from "./files/Lead_Management_User_Guide.pdf";

import ScrollToTopButton from "./helper/scrollToTopButton";
import LoginScreen from "./auth/loginScreen";
import { Dialog, DialogContent } from "@mui/material";
import ZulipChat from "./helper/ZulipChat";
import axios from "axios";
import { WhiteChatIcon } from "./component/icons/icons";
import { IconButton } from "@mui/material";
import { Toaster } from "react-hot-toast";
import useContactUsIcon from "./helper/useJiraWidget.ts";
import { getAppDomain } from "./helper/getAppDomain.js";

// Import authorised component with lazy loading
const Routing = React.lazy(() => import("./auth/route"));
let helpDoc;
let count = 0;
let countriesLoadCount = 0;
let publicBrowsing = false;
let absoluteDomain = getAppDomain() || "";

const App = (props) => {
  const editorRef = useRef(null);
  let tenantData = {};
  if (props.tenantId || props.publicBrowsing) {
    tenantData = props.tenantData;
    if (!props.tenantData.styleSheet) {
      require("./default.css");
    }
  }
  if (props.locale) {
    let locale = props.locale.replace(".", "");
    if (count === 0) {
      if (props.tenantInfo.tenantId === "geolocstar") {
        locale = "en_ooredoo";
      }
      props.i18n.changeLanguage(locale);
      count++;
    }
  }
  const location = useLocation();

  // const defaultTheme = createTheme();
  // Object.assign(defaultTheme, {
  // 	overrides: {
  // 		MUIRichTextEditor: {
  // 			editor: {
  // 				borderBottom: "1px solid gray",
  // 				borderTop: "1px solid gray",
  // 				minHeight: 100
  // 			}
  // 		}
  // 	}
  // })

  useEffect(() => {
    console.log("Webapp V4.01");
    props.setCompDidMount();
    props.clearCart();
    window.scrollTo(0, 0);

    let path = location.pathname;
    // if (!path.includes('order') && !path.includes('activate') && !path.includes('callback')) {
    // 	localStorage.removeItem('orderFilters');
    // }
    if (
      !path.includes("order") &&
      !path.includes("activate") &&
      !path.includes("reports") &&
      !path.includes("callback")
    ) {
      localStorage.removeItem("statsOrderFilters");
    }
    if (!path.includes("subscription") && !path.includes("callback")) {
      localStorage.removeItem("subscriptionStatsFilters");
    }

    if (props.authenticated && countriesLoadCount === 0) {
      BusApiCall("GET", `${constants.busOpenServiceUrl}/countries`, {}).then(
        (res) => {
          if (res.data && res.data.length > 0) {
            props.setCountriesList(res.data);
            countriesLoadCount++;
          } else {
            props.setCountriesList([]);
          }
        },
      );
      // .catch(err => {
      // 	if (err.response && err.response.data && err.response.data.message) {
      // 		props.setErrorMessage(err.response.data.message, false)
      // 	} else {
      // 		props.setErrorMessage(props.t('FAILED_TO_LOAD_COUNTRIES'), false)
      // 	}
      // })
    }

  }, [location]);

  let doLogin = JSON.parse(localStorage.getItem("doLogin"));
  const [loading, setLoading] = useState(false);
  const [showHelp, setShowhelp] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [helpData, setHelpData] = useState({
    title: "",
    helpContent:
      '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    route: "",
    requestType: "post",
  });
  const toggleDrawer = (open) => {
    var admin = props.roles.includes("ADMIN");
    setHelpData({});
    if (open) {
      console.log("check location.pathname", location.pathname);
      if (
        location.pathname == "/myOfferings" ||
        location.pathname == "/productOfferingRules" ||
        location.pathname == "/createSpecialPrice"
      ) {
        helpDoc = OfferingGuidePdf;
      } else if (location.pathname == "/products") {
        helpDoc = ServiceUserGuidePdf;
      } else if (
        location.pathname == "/createPackage" ||
        location.pathname == "/updatePackage"
      ) {
        helpDoc = OfferingGuidePdf;
      } else if (
        location.pathname == "/orders" ||
        location.pathname.includes("/order/")
      ) {
        helpDoc = OrderUserGuidePdf;
      } else if (location.pathname === "/manageCustomers") {
        helpDoc = CustomerUserGuidePdf;
      } else if (
        location.pathname.includes("/quote") ||
        location.pathname.includes("/newOrder")
      ) {
        helpDoc = QuoteUserGuidePdf;
      } else if (location.pathname === "/billing") {
        helpDoc = BillingUserGuidePdf;
      } else if (location.pathname === "/subscriptions") {
        helpDoc = SubscriptionUserGuidePdf;
      } else if (location.pathname === "/assets") {
        helpDoc = AddonUserGuidePdf;
      } else if (location.pathname === "/settlement") {
        helpDoc = SettlementGuidePdf;
      } else if (
        location.pathname === "/orderReport" ||
        location.pathname === "/billingRecords" ||
        location.pathname === "/paymentReport" ||
        location.pathname === "/orderReport" ||
        location.pathname === "/stats" ||
        location.pathname.includes("/report")
      ) {
        helpDoc = ReportsGuidePdf;
      } else if (location.pathname === "/dashboard") {
        helpDoc = DashboardPdf;
      } else if (location.pathname === "/manageLeads") {
        helpDoc = LeadsManagementGuidePdf;
      } else {
        helpDoc = generalPdf;
      }
      // setIsAdmin(admin);
      // if (location.pathname === '/newOrder' || location.pathname === '/product') {
      // 	searchHelpData('/product');
      // } else if (location.pathname.includes('/newOrder/') || location.pathname.includes('/product/') || location.pathname.includes('/viewSolution/')) {
      // 	searchHelpData('/newOrder/{}');
      // } else if (location.pathname.includes('/confirmOrder')) {
      // 	searchHelpData('/confirmOrder');
      // } else {
      // 	if (location.pathname.split('/').length === 2) {
      // 		searchHelpData(location.pathname);
      // 	} else {
      // 		searchHelpData('/' + location.pathname.split('/')[1] + '/{}')
      // 	}
      // }
    } else {
      setIsAdmin(false);
    }
    setShowhelp(open);
  };

  const searchHelpData = (page) => {
    setLoading(true);
    for (var i = 0; i < helpScreensList.length; i++) {
      if (helpScreensList[i].route === page) {
        var tempHelpData = {
          helpContent:
            '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
          route: helpScreensList[i].route,
          title: helpScreensList[i].title,
          requestType: "put",
        };
        setHelpData(tempHelpData);
        BusApiCall(
          "GET",
          `${constants.busInternalUrl}/sales/help?pageId=${page}`,
        )
          .then((res) => {
            var help = {
              helpContent: res.data.helpContent,
              route: helpScreensList[i].route,
              title: helpScreensList[i].title,
              requestType: "put",
            };
            setHelpData(help);
            setLoading(false);
          })
          .catch((err) => {
            var help = {
              helpContent:
                '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
              route: helpScreensList[i].route,
              title: helpScreensList[i].title,
              requestType: "post",
            };
            setHelpData(help);
            setLoading(false);
            // if (err.response && err.response.data && err.response.data.message) {
            // 	props.setErrorMessage(err.response.data.message, false)
            // } else {
            // 	props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
            // }
          });
        return;
      }
    }
  };

  const save = (event) => {
    setLoading(true);
    var payload = {
      helpContent: event,
      pageId: helpData.route,
    };
    var requestType = helpData.requestType === "put" ? "PUT" : "POST";
    BusApiCall(requestType, `${constants.busInternalUrl}/sales/help`, payload)
      .then((res) => {
        var help = {
          helpContent: helpData.helpContent,
          route: helpData.route,
          title: helpData.title,
          requestType: "put",
        };
        setHelpData(help);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
      });
  };

  const handleEditor = () => {
    if (editorRef.current) {
      editorRef.current.save();
    }
  };

  const [jiraPortalId, setJiraPortalId] = useState(undefined);
  const [jiraKeyValue, setJiraKey] = useState(undefined);
  const [testStarted, setTestStarted] = useState(false);
  const [testInstructionsOpen, setTestInstructionsOpen] = useState(false);

  // Hook: load/hide Jira widget
  useContactUsIcon(testStarted, testInstructionsOpen, jiraKeyValue);

  useEffect(() => {
    if (
      props.authenticated &&
      props.modules?.module_tickets === "enabled"
    ) {
      const userData = JSON.parse(localStorage.getItem("roles") || "{}");
      const jiraKey = userData?.data?.jiraDataKey;
      const jiraPortalId = userData?.data?.jiraPortalId;

      if (jiraKey) {
        setJiraKey(jiraKey);
        if (jiraPortalId) {
          setJiraPortalId(jiraPortalId);
        }
        // Use the new key safely in timeout
        setTimeout(() => {
          // Use functional updates to avoid stale state
          setTestStarted((prev) => !prev);
          setTestInstructionsOpen((prev) => !prev);
        }, 1000);
      }
    }
    if (props.authenticated) { } else {
      const userData = JSON.parse(localStorage.getItem("roles") || "{}");
      if (userData.data && userData.data.tenantId) { } else {
        if (location.pathname === '/manageLeads') {
          var url = location.pathname + location.search;
          var Cookies = document.cookie.split(";");
          for (var i = 0; i < Cookies.length; i++) {
            if (
              window.location.protocol === "https:" ||
              window.location.protocol === "HTTPS:"
            ) {
              document.cookie =
                Cookies[i].split("=")[0] +
                "=; path=/; domain=" +
                absoluteDomain +
                "; secure; expires=" +
                new Date(0).toUTCString();
            } else {
              document.cookie =
                Cookies[i].split("=")[0] +
                "=; path=/; domain=" +
                absoluteDomain +
                "; expires=" +
                new Date(0).toUTCString();
            }
          }
          localStorage.clear();
          sessionStorage.clear();
          localStorage.setItem("redirectUrl", url);
          window.location.href = '/';
        }
      }
    }
  }, [props.authenticated, props.modules]);

  return (
    <React.Fragment>
      {(props.tenantId || props.publicBrowsing) && (
        <Helmet>
          <title>
            {tenantData.title ? tenantData.title : "Digitize Things"}
          </title>
          <meta
            name="description"
            content={
              tenantData.description
                ? tenantData.description
                : "Digitize Things"
            }
          />
          {tenantData.favIcon ? (
            tenantData.favIcon.startsWith("data:image") ? (
              <link rel="icon" href={tenantData.favIcon} />
            ) : (
              <link
                rel="icon"
                href={
                  "data:image/png;base64," +
                  decodeURIComponent(tenantData.favIcon)
                }
              />
            )
          ) : (
            <link rel="icon" href="./favicon.ico" />
          )}
          <style type="text/css">{tenantData.css}</style>
        </Helmet>
      )}
      {/* <Helmet>
				{props.authenticated && props.modules && props.modules.module_tickets && props.modules.module_tickets === 'enabled' &&
					<script data-jsd-embedded data-key="0cd58798-9371-4bfa-aa87-3465aa1bcd29"
						data-base-url="https://jsd-widget.atlassian.com" src="https://jsd-widget.atlassian.com/assets/embed.js"></script>
				}
			</Helmet> */}
      {/* Check for user session from redux store */}
      {!window.location.pathname.includes("/partner/") &&
        (props.authenticated || props.publicBrowsing) ? (
        // Authorised routes
        <React.Fragment>
          {/* Loading with suspense when data is being fetched */}
          <Suspense fallback={<Loader loading={true} top={"40%"} />}>
            {/* Added authorised routes component */}
            <Routing />
          </Suspense>
        </React.Fragment>
      ) : (
        // Unauthorised routes
        <>
          <React.Fragment>
            <Routes>
              <Route path="/confirmOrder/:id" element={<ConfirmOrder />} />
              <Route path="/api-portal" element={<ApiPortal />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/api-read-only" element={<ApiReadOnly />} />
              <Route path="/sdk" element={<SDK />} />
              <Route path="/api-ref" element={<ApiRef />} />
              {/* <Route path="/internal-api" element={<InternalAPI />} /> */}

              <Route path="/callback" element={<Callback />} />
              <Route path="/silentcallback" element={<SilentCallback />} />
              {/* <Route path="/signUp" element={<SignUp />} /> */}

              <Route path="/login" element={<LoginScreen />} replace />
              <Route path="/partner/:partnerId" element={<LoginScreen />} />

              {/* Default route or fallback */}
              <Route path="/" element={<Login />} replace />

              {/* Catch-all redirect for unknown routes */}
              {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
            </Routes>
          </React.Fragment>
        </>
      )}
      <>
        <Tooltip title={props.t("HELP")}>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            onClick={(e) => toggleDrawer(true)}
            xmlns="http://www.w3.org/2000/svg"
            className="pageHelpIcon"
          >
            <circle cx="8.30078" cy="8" r="8" fill="var(--primary-color)" />
            <path
              d="M8.90377 13.7467C8.66911 13.7467 8.47177 13.6827 8.31177 13.5547C8.16244 13.4267 8.08777 13.2347 8.08777 12.9787V6.48275C8.08777 6.22675 8.16244 6.03475 8.31177 5.90675C8.47177 5.76808 8.66911 5.69875 8.90377 5.69875C9.13844 5.69875 9.33044 5.76808 9.47977 5.90675C9.62911 6.03475 9.70377 6.22675 9.70377 6.48275V12.9787C9.70377 13.2347 9.62911 13.4267 9.47977 13.5547C9.33044 13.6827 9.13844 13.7467 8.90377 13.7467ZM8.90377 4.13075C8.59444 4.13075 8.34911 4.04541 8.16777 3.87475C7.98644 3.70408 7.89577 3.48008 7.89577 3.20275C7.89577 2.92541 7.98644 2.70675 8.16777 2.54675C8.34911 2.37608 8.59444 2.29075 8.90377 2.29075C9.20244 2.29075 9.44244 2.37608 9.62377 2.54675C9.81577 2.70675 9.91177 2.92541 9.91177 3.20275C9.91177 3.48008 9.82111 3.70408 9.63977 3.87475C9.45844 4.04541 9.21311 4.13075 8.90377 4.13075Z"
              fill="white"
            />
          </svg>
        </Tooltip>
        <Drawer
          anchor={"right"}
          open={showHelp}
          onClose={() => toggleDrawer(false)}
        >
          <h2 style={{ marginTop: 0 }}>{helpData.title}</h2>
          <div>
            <iframe
              src={helpDoc}
              style={{ width: "100%", height: "100vh" }}
            ></iframe>
            {/* <MuiThemeProvider theme={defaultTheme}>
							<MUIRichTextEditor
								label={isAdmin ? props.t('ENTER_HELP_CONTENT') : ''}
								onSave={event => save(event)}
								inlineToolbar={isAdmin ? true : false}
								toolbar={isAdmin ? true : false}
								value={helpData.helpContent}
								ref={editorRef}
								readOnly={!isAdmin}
							/>
						</MuiThemeProvider> */}
          </div>
          {isAdmin && (
            <div align="right" style={{ marginTop: 16 }}>
              <Button onClick={() => handleEditor()}>{props.t("SAVE")}</Button>
            </div>
          )}
        </Drawer>
      </>
      {props.authenticated &&
        props.modules &&
        props.modules.module_chat &&
        props.modules.module_chat === "enabled" && (
          <>
            <ZulipChat />
          </>
        )}
      {window.location.pathname !== "/login" &&
        !window.location.pathname.includes("/partner/") && (
          <>
            {!props.publicBrowsing && !props.tenantId && !doLogin && (
              <div className="init-app-global-loader">
                <div className="global-loader-icon"></div>
                <div className="global-loader-text">
                  {props.t("LOADING_MESSAGE")}
                </div>
              </div>
            )}
          </>
        )}
      <Loader loading={loading} />
      {/* <ZulipChat /> */}
      <ScrollToTopButton />
      <Toaster position="top-center" />
    </React.Fragment>
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.authenticated,
    tenantId: state.auth.tenantId,
    tenantData: state.auth.tenantData,
    locale: state.auth.tenantLocale,
    publicBrowsing: state.auth.publicBrowsing,
    roles: state.auth.roles,
    tenantInfo: state.auth.tenantInfo,
    modules: state.auth.modules,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    clearCart: () => dispatch({ type: actionTypes.CLEAR_CART }),
    setCountriesList: (data) =>
      dispatch({ type: actionTypes.SET_COUNTRIES_LIST, data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(App));
